import { WPFMessageType } from '@/enums';

export const postAudioDeviceChangeMessage = (isHeadPhone: boolean) => {
    if (window.chrome?.webview) {
        window.chrome.webview.postMessage({
            type: WPFMessageType.AudioDeviceChange,
            confirmed: isHeadPhone,
        });
    }
};
